import {
  HTTP_QUOTATIONDT_FETCHING,
  HTTP_QUOTATIONDT_SUCCESS,
  HTTP_QUOTATIONDT_FAILED
} from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_QUOTATIONDT_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_QUOTATIONDT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_QUOTATIONDT_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
